import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './SwitchInput.module.scss';
import { t } from 'utils';

export interface ISwitchInput extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  label: string;
  disabled?: boolean;
}

const SwitchInput: FC<ISwitchInput> = (props) => {
  const { label, disabled, className, ...otherProps } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.disabled]: disabled,
  });

  return (
    <div className={rootClassName}>
      <label className={styles.checkbox}>
        <input className='visually-hidden' {...otherProps} />
        <span className={styles.input} />
        <span className={styles.label}>{t(label)}</span>
      </label>
    </div>
  );
};

export default SwitchInput;
